import {Injectable} from '@angular/core';
import {doc, Firestore, getDoc} from '@angular/fire/firestore';
import {ITypeSenseApiDoc} from '../../shared-models/type-sense/type-sense-types';
import {IStore} from '../../shared-models/store/store';
import {path_stores_storeId_docs_typesense_key} from '../database-paths';

@Injectable({
  providedIn: 'root',
})
export class CollectionStoresDocsService {

  constructor(private firestore: Firestore) {
  }

  async getAllTypesenseApiKeysForStores(stores: IStore[]): Promise<Record<string, ITypeSenseApiDoc>> {
    const allDocs: Record<string, ITypeSenseApiDoc> = {};

    await Promise.all(stores.map(async (store: IStore) => {
      const storeId = store.storeId;
      const docRef = doc(this.firestore, path_stores_storeId_docs_typesense_key(storeId));
      const docSnapshot = await getDoc(docRef);
      if (docSnapshot.exists()) {
        allDocs[storeId] = docSnapshot.data() as ITypeSenseApiDoc;
      }
    }));

    return allDocs;
  }


}
